export default __webpack_public_path__ + "static/media/product-1.7a03b14f.jpg";